import { Button, Input, RowItem } from '@/components';
import type { IRowItemProps } from '@/components/layout/bordered-layout/row-item';
import { getFieldInputProps } from '@/utils';

import { FormikProps } from 'formik';

import { useLogic } from './logic';

type TEmailVerifyField = {
	formik: FormikProps<{ [key: string]: any }> | any;
	fieldName?: string;
	placeholder?: string;
	disabled?: boolean;
	required?: boolean;
	isDetail?: boolean;
} & IRowItemProps;

const EmailVerifyField = ({
	formik,
	label = '아이디(이메일)',
	fieldName = 'email',
	placeholder,
	disabled,
	required = false,
	isDetail,
	...rest
}: TEmailVerifyField) => {
	const { t, verifyEmail, handleEmailChange, isAvailableEmail } =
		useLogic(formik);

	return (
		<RowItem label={label} required={required} {...rest}>
			<div className="w-full flex gap-2">
				<Input
					{...getFieldInputProps(formik, fieldName)}
					maxLength={100}
					isValidValue={isAvailableEmail}
					onChange={handleEmailChange}
					placeholder={placeholder}
					disabled={disabled}
					isDetail={isDetail}
					containerClassName="w-full"
				/>
				{!disabled ? (
					<Button
						secondary
						className="!min-w-[80px] font-normal text-[13px] h-[30px]"
						onClick={verifyEmail}
						disabled={!required && !formik.values[fieldName]}
					>
						{t('duplicated-check')}
					</Button>
				) : null}
			</div>
		</RowItem>
	);
};

export default EmailVerifyField;
